<div class="page">
  <div class="success-banner">
    <i class="pi pi-check-circle"></i>
    <div>
      <h2>Payment successful</h2>
      <p>The member is now insured. Here's the receipt — print or download it for your records.</p>
    </div>
  </div>

  <div class="card receipt-card">
    @if (paymentId()) {
      <app-receipt-view [paymentId]="paymentId()" />
    } @else {
      <div class="state"><i class="pi pi-exclamation-triangle"></i><p>No payment reference provided.</p></div>
    }
  </div>

  <div class="page-foot">
    @if (memberId()) {
      <p-button label="View Certificate" icon="pi pi-id-card" [outlined]="true" (onClick)="viewCertificate()" />
    }
    <p-button label="Find another receipt" icon="pi pi-search" [outlined]="true" (onClick)="findAnother()" />
    <p-button label="Done" icon="pi pi-check" (onClick)="done()" />
  </div>
</div>
